import { AuthApi } from '../auth/authApi';
import { Singleton } from '@/decorators';
import type {
  GetExternalLookupRequestDTO,
  GetExternalLookupResponseDTO,
  GetInternalLookupListResponseDTO,
} from './DTOs';
import type { Result } from '@/types/result.interface';
import type { AppError } from '@/types/errors.interface';
import { wrapHttpCall } from '../utils/apiResultMapper';

/**
 * Lookup API (Framework Agnostic)
 * 
 * Handles lookup data retrieval for internal and external lookups.
 */
@Singleton
export class LookupApi extends AuthApi {
  constructor() {
    super();
  }

  async getInternalLookupList(): Promise<Result<GetInternalLookupListResponseDTO, AppError>> {
    return wrapHttpCall(() => this.api.get<GetInternalLookupListResponseDTO>(
      `/Lookup/internal/list`,
    ));
  }

  async getExternalLookup(body: GetExternalLookupRequestDTO): Promise<Result<GetExternalLookupResponseDTO, AppError>> {
    return wrapHttpCall(() => this.api.post<GetExternalLookupResponseDTO>(
      `/Lookup/external`,
      body,
    ));
  }
}
